import { Component, OnInit, ChangeDetectorRef, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { CoreLogService } from "../../services/log.service";
import { TermViewModel } from "../../shared/models/term.model";
import { TermDialogService } from "./termDialog.service";

@Component({
  selector: "termdialog",
  templateUrl: "./termDialog.component.html",
  styleUrls: ["./termDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermDialogComponent implements OnInit {
  public termViewModel: TermViewModel;
  constructor(private termDialogService: TermDialogService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public termViewModelId: number,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    public bottomSheetRef: MatBottomSheetRef<TermDialogComponent>) {
    this._changeDetectorRef.detach();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("termDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.termDialogService.GetTermViewModelBuId(me.termViewModelId)
      .then(term => {
        me.termViewModel = term;
        me.PushChanges();
        setTimeout(() => {
          document.getElementById("termContent").scrollTop = 0;
        });
      });
  }

}
